import React, { useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useLoading } from 'hooks/useLoading';
import ExperienceService from 'services/ExperienceService';
import IExperience from 'interfaces/IExperience';
import Heading from 'components/Heading';
import {
  SettingsList,
  SettingsListContainer,
  SettingsListItem,
  SettingsListItemButton,
  SettingsListItemButtonList,
  SettingsListItemTitle,
} from 'components/List/styles';
import { SettingsContainer, SettingsHeader } from 'components/SettingsBox/styles';
import editIcon from 'assets/images/editIcon.svg';
import { touristicExperiencesTypes } from 'features/TourActivityForm/components/TourSeturForm/utils';

const ExperienceCarouselConfig = (): JSX.Element => {
  const history = useHistory();
  const [experiences, setExperiences] = useState<IExperience[]>([]);
  const { openLoading, closeLoading } = useLoading();
  const experienceService = new ExperienceService();

  const fetchExperiences = async () => {
    try {
      openLoading();
      const list = await experienceService.findAll();
      setExperiences(list);
    } catch (error) {
      console.error('Erro ao carregar experiências:', error);
    } finally {
      closeLoading();
    }
  };

  useEffect(() => {
    fetchExperiences();
  }, []);

  // Lista unificada das experiências vindas do backend ou fallback das inseridas no frontend
  const listItems: IExperience[] = useMemo(() => {
    if (experiences.length > 0) return experiences;
    return touristicExperiencesTypes.map((item, index) => ({
      id: index + 1,
      title: item.label,
      image: '',
      link: '',
      banners: [],
    }));
  }, [experiences]);

  const handleEditExperience = (item: IExperience) => {
    // Busca a experiência correspondente para obter o id correto
    const found = experiences.find(e => e.id === item.id || e.title.toLowerCase() === item.title.toLowerCase()) || item;
    history.push(`/admin/experiences/${found.id}`);
  };

  return (
    <SettingsContainer>
      <SettingsHeader>
        <Heading>Carrossel</Heading>
      </SettingsHeader>

      <SettingsListContainer>
        <SettingsList style={{ maxHeight: '420px' }}>
          {listItems.map(item => {
            const bannerCount = item.banners?.length || 0;

            return (
              <SettingsListItem key={item.id}>
                <SettingsListItemTitle style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span>{item.title}</span>
                </SettingsListItemTitle>

                <SettingsListItemButtonList>
                  <SettingsListItemButton
                    type="button"
                    onClick={() => handleEditExperience(item)}
                    title="Editar carrossel">
                    <img src={editIcon} alt="Editar carrossel" />
                  </SettingsListItemButton>
                </SettingsListItemButtonList>
              </SettingsListItem>
            );
          })}
        </SettingsList>
      </SettingsListContainer>
    </SettingsContainer>
  );
};

export default ExperienceCarouselConfig;
